(() => {
  if (!window.location.pathname.includes('/collections/portable-cooling')) return;

  const styleId = 'veltronics-inline-quick-add-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .veltronics-inline-quick-add { margin: 0 0 1rem; }
      .card--card .veltronics-inline-quick-add { margin-left: 1.3rem; margin-right: 1.3rem; }
      .veltronics-inline-quick-add__label { display:block; font-size:1.3rem; line-height:1.4; margin:0 0 .6rem; text-align:left; }
      .veltronics-inline-quick-add .select { width:100%; margin-bottom:.8rem; }
      .veltronics-inline-quick-add .select__select { width:100%; min-height:4.4rem; font-size:1.4rem; padding-left:1.4rem; padding-right:3.6rem; }
      .veltronics-inline-quick-add__button { min-height:4.4rem; }
      .veltronics-inline-quick-add__status { display:block; min-height:1.8rem; margin-top:.4rem; font-size:1.15rem; line-height:1.3; text-align:center; opacity:.75; }
      @media screen and (max-width:749px) {
        .veltronics-inline-quick-add__label { font-size:1.15rem; }
        .veltronics-inline-quick-add .select__select { min-height:4rem; font-size:1.25rem; }
        .veltronics-inline-quick-add__button { min-height:4rem; padding:.8rem .9rem; font-size:1.3rem; }
      }
    `;
    document.head.appendChild(style);
  }

  const productCache = new Map();
  const nonColourTokens = /^(usb|type[- ]?c|au|eu|us|uk|color box|colour box|no box|with box)$/i;

  const colourLabel = (title = '') => {
    const parts = title.split('/').map((part) => part.trim()).filter(Boolean);
    const candidate = parts.find((part) => !nonColourTokens.test(part));
    return candidate || parts[0] || title;
  };

  const getProduct = (productUrl) => {
    const cleanUrl = productUrl.split('?')[0].replace(/\/$/, '');
    if (!productCache.has(cleanUrl)) {
      productCache.set(
        cleanUrl,
        fetch(`${cleanUrl}.js`, { headers: { Accept: 'application/json' } }).then((response) => {
          if (!response.ok) throw new Error('Unable to load product options');
          return response.json();
        })
      );
    }
    return productCache.get(cleanUrl);
  };

  const updateCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    const icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;

    let bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble && cart.item_count > 0) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      icon.appendChild(bubble);
    }
    if (!bubble) return;
    if (cart.item_count <= 0) {
      bubble.remove();
      return;
    }
    const visible = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
    const hidden = bubble.querySelector('.visually-hidden');
    if (visible) visible.textContent = String(cart.item_count);
    if (hidden) hidden.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
  };

  const addVariant = async (variantId, button, status) => {
    const root = window.Shopify?.routes?.root || '/';
    const originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Adding…';
    status.textContent = '';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item');

      await updateCartCount();
      button.textContent = 'Added ✓';
      status.textContent = 'Added to cart';
      window.setTimeout(() => {
        button.textContent = originalText;
        status.textContent = '';
      }, 1200);
    } catch (error) {
      button.textContent = originalText;
      status.textContent = error.message || 'Could not add this item';
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }, 300);
    }
  };

  const buildInlineSelector = async (opener) => {
    if (opener.dataset.veltronicsEnhanced === 'true') return;
    opener.dataset.veltronicsEnhanced = 'true';

    const trigger = opener.querySelector('button[data-product-url]');
    if (!trigger) return;
    const productUrl = trigger.dataset.productUrl;
    if (!productUrl) return;

    try {
      const product = await getProduct(productUrl);
      const variants = (product.variants || []).filter((variant) => variant.available);
      if (!variants.length) return;

      const container = document.createElement('div');
      container.className = 'veltronics-inline-quick-add';

      const label = document.createElement('label');
      label.className = 'veltronics-inline-quick-add__label';
      label.textContent = 'Choose colour';

      const selectWrapper = document.createElement('div');
      selectWrapper.className = 'select';

      const select = document.createElement('select');
      select.className = 'select__select veltronics-inline-quick-add__select';
      select.setAttribute('aria-label', 'Choose colour');

      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = colourLabel(variant.title);
        select.appendChild(option);
      });

      const caret = document.createElement('span');
      caret.className = 'svg-wrapper';
      caret.setAttribute('aria-hidden', 'true');
      caret.innerHTML = '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L5 4.293 8.646.646a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>';
      selectWrapper.append(select, caret);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--full-width button--secondary veltronics-inline-quick-add__button';
      button.textContent = 'Add to cart';

      const status = document.createElement('span');
      status.className = 'veltronics-inline-quick-add__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      button.addEventListener('click', () => addVariant(select.value, button, status));

      container.append(label, selectWrapper, button, status);
      const modalId = opener.dataset.modal;
      opener.replaceWith(container);
      if (modalId) document.querySelector(modalId)?.remove();
    } catch (error) {
      opener.dataset.veltronicsEnhanced = 'false';
    }
  };

  const enhance = (root = document) => {
    root.querySelectorAll?.('modal-opener[data-modal^="#QuickAdd-"]').forEach(buildInlineSelector);
  };

  enhance();
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('modal-opener[data-modal^="#QuickAdd-"]')) buildInlineSelector(node);
        enhance(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
